import React from "react";
import styled from "styled-components";
import CheckIcon from "sweet-web/components/icons/CheckIcon";
import { colors } from "sweet-web/lib/styles";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: 5px 0;
  width: 100%;
`;

const Button = styled.button<{ active: boolean }>`
  border-radius: 5px;
  border: 1px solid
    ${props => (props.active ? colors.primary : colors.lightGray)};
  padding: 10px 15px;
  color: ${props => (props.disabled ? colors.gray : colors.nearBlack)};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  outline: none;
  background: ${colors.white};
  font-size: 14px;
  font-weight: 600;
  margin: 5px 0;
  width: 100%;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  &:hover {
    border: 1px solid
      ${props => (props.disabled ? colors.gray : colors.primary)};
    box-shadow: rgba(88, 29, 208, 0.08) 0 5px 10px 0;
  }
`;

const Circle = styled.span<{ active: boolean }>`
  height: 14px;
  width: 14px;
  border-radius: 7px;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  border: 1px solid
    ${props => (props.active ? colors.primary : colors.lightGray)};
  background-color: ${props => (props.active ? colors.primary : colors.white)};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
`;

type Props = {
  activeValue: string;
  values: Array<{
    name: string;
    title: string;
    disabled?: boolean;
  }>;
  onChange: (newValue: string) => void;
};

const Toggle: React.FC<Props> = props => (
  <Wrapper>
    {props.values.map(value => {
      const active = props.activeValue === value.name;

      return (
        <Button
          active={active}
          key={`toggle-button-${value.name}`}
          onClick={() => props.onChange(value.name)}
          disabled={value.disabled === true}
        >
          <Circle active={active}>
            <CheckIcon
              color={colors.white}
              height={6}
              style={{ transform: "translateY(-1px)" }}
            />
          </Circle>
          {value.title}
        </Button>
      );
    })}
  </Wrapper>
);

export default Toggle;
